import { Card, Space, Divider } from "antd";
import styled from "styled-components";
import type { CustomMarker } from "../../../context/CustomMarkersContext";

const PopupPanel = styled(Card)`
  color: #eeeeee;
  border-radius: 8px;
  width: 200px;
  font-family: veterantypewriter !important;
  .ant-card-body {
    padding: 12px 16px;
  }
`;

const HeaderRow = styled.div`
  font-weight: 700;
  letter-spacing: 0.25px;
  margin-bottom: 8px;
`;

const InfoSpace = styled(Space)`
  margin-top: 4px;
  width: 100%;
  font-size: 12px;
`;

const DetailRowFlex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const LabelText = styled.span`
  flex: 0 0 auto;
`;

const ValueText = styled.span`
  text-align: end;
  flex: 1 1 auto;
`;

const DescriptionText = styled.div`
  font-size: 12px;
  color: #cccccc;
  white-space: pre-wrap;
  word-break: break-word;
  a {
    color: #8e1616;
    text-decoration: underline;
    pointer-events: all;
    cursor: pointer;
  }
`;

const ColorDivider = styled(Divider)<{ $color: string }>`
  margin: 8px 0;
  border-top: 2px solid ${(p) => p.$color};
  border-radius: 2px;
`;

export function CustomMarkerPopupContent({
  marker,
  color,
}: {
  marker: CustomMarker;
  color: string;
}) {
  const dateStr = marker.date ? marker.date.format("YYYY-MM-DD") : null;

  return (
    <PopupPanel variant="borderless">
      <HeaderRow>{marker.name || "Marker"}</HeaderRow>
      <InfoSpace direction="vertical" size={6}>
        {dateStr && (
          <DetailRowFlex>
            <LabelText>Date</LabelText>
            <ValueText>{dateStr}</ValueText>
          </DetailRowFlex>
        )}
        {marker.description && (
          <DescriptionText
            dangerouslySetInnerHTML={{ __html: marker.description }}
          />
        )}
      </InfoSpace>
      <ColorDivider $color={color} />
    </PopupPanel>
  );
}
